import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetWarehouseCustomersQuery = (enabled = true) => {
  return useQuery({
    queryKey: ['getWarehouseCustomers'],
    queryFn: () => Api.wms.getWarehouseCustomers(),
    enabled,
  });
};
